import PropTypes from "prop-types";
import React, { Component } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import _ from "lodash";
class Magazine extends Component {
  // var Loader = require('react-loader');
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    };
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props.marketCode, prevProps.marketCode)) {
      this.setState({
        isLoading: true,
      });
    }
  }

  getSrcUrl = (newMarketID, marketId, flipSnackId, marketCode, urlPart) => {
    //hardcode only for hamptons on zeus move it to regions collection and handle it
    if (urlPart === "hamptons") {
      return "https://sirhamptons.foleon.com/marketupdate/sirhamptonsmarketupdate/";
    }

    //hardcode for nyc as new url does not match the pattern 
    if (urlPart === "nyc") {
      return "https://d3ms8mre5rhtvu.cloudfront.net/?hash=Njc1QkE3NjZBRUQremhuMGptbnZ4bg==&cd=https://homes.sothebysrealty.com";
    }

    if (marketCode && marketCode !== "") {
      if (marketCode === "monterey") {
        if (
          //harded the market update for Santa Cruz Brokerage in monterey - santa_cruz_county
          this.props.officeId.toLowerCase() ===
          "cbed6cd1-97c3-4ab3-ad05-b1946969d067" //Santa Cruz Brokerage office id
        ) {
          return `https://marketupdates.sothebysrealty.com/marketupdate/${marketCode}/santa_cruz_county`;
        } else {
          //harded the market update for Santa Cruz Brokerage in monterey - monterey_peninsula
          return `https://marketupdates.sothebysrealty.com/marketupdate/${marketCode}/monterey_peninsula`;
        }
      } else {
        return `https://marketupdates.sothebysrealty.com/marketupdate/${marketCode}`;
      }
    } else if (flipSnackId) {
      return `https://d1dhn91mufybwl.cloudfront.net/widget/v2/widget.html?hash=${flipSnackId}&cd=http://homes.sothebysrealty.com`;
    } else if (newMarketID) {
      return `//e.issuu.com/embed.html?backgroundColor=%23ffffff&backgroundColorFullscreen=%23ffffff&d=${newMarketID}&hideIssuuLogo=true&u=sirinc`;
    } else if (marketId) {
      return `//e.issuu.com/embed.html#${marketId}`;
    }
  };

  updateLoader = () => {
    this.setState({
      isLoading: false,
    });
  };

  render() {
    return (
      <div className={this.state.isLoading ? "newFrame loader" : "newFrame"}>
        {this.state.isLoading ? (
          <CircularProgress style={{ color: "#fff" }} />
        ) : (
          ""
        )}
        <iframe
          onLoad={this.updateLoader}
          id="idIframe"
          frameBorder="0"
          src={this.getSrcUrl(
            this.props.newMarketID,
            this.props.marketId,
            this.props.flipSnackId,
            this.props.marketCode,
            this.props.urlPart
          )}
          width="100%"
          height="auto"
          allowFullScreen
          key={
            this.props.marketId ||
            this.props.newMarketID ||
            this.props.flipSnackId ||
            this.props.marketCode
          }
        />
      </div>
    );
  }
}

Magazine.propTypes = {
  newMarketID: PropTypes.string,
  marketId: PropTypes.string,
  flipSnackId: PropTypes.string,
  marketCode: PropTypes.string,
};

export default Magazine;



// WEBPACK FOOTER //
// ./src/components/market-update/magazine.js